import {Component, forwardRef, Input, OnDestroy, OnInit, Provider} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormGroup
} from '@angular/forms';
import {Subscription} from 'rxjs';

import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import ClassicEditorBuild from '@ckeditor/ckeditor5-build-decoupled-document';
import {NgClass, NgStyle} from "@angular/common";
import {CKEditorModule} from "@ckeditor/ckeditor5-angular";


const PREFERENCE_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RichEditorComponent),
  multi: true
};

@Component({
    selector: 'app-rich-editor',
    templateUrl: './rich-editor.component.html',
    styleUrls: ['./rich-editor.component.scss'],
    providers: [PREFERENCE_CONTROL_VALUE_ACCESSOR],
    imports: [
        NgClass,
        NgStyle,
        CKEditorModule,
        ReactiveFormsModule
    ]
})
export class RichEditorComponent implements OnInit, OnDestroy, ControlValueAccessor {

  public Editor = ClassicEditorBuild;

  public config = {
    placeholder: 'Type the content here !',
    toolbar: {
      items: ['heading', '|', 'alignment', '|', 'bold', 'italic', '|', 'undo', 'redo', '|', 'numberedList', 'bulletedList', '|', 'link', '|', 'insertTable'],
      shouldNotGroupWhenFull: true
    },
    heading: {
      options: [
        {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
        {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
        {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
        {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'},
        {model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'},
        {model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'},
        {model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'}
      ]
    },
    removePlugins: [],
    language: 'en'

  }

  public onReady(editor: typeof DecoupledEditor) {
    editor.ui
      .getEditableElement()
      .parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement(),
    );
    editor.plugins.get('ClipboardPipeline')
    if (this.isReadOnly) {
    editor.enableReadOnlyMode('lock-editor');
    console.log(editor)
  }
  }

  @Input() isSubmitted: boolean = false;
  @Input() isReadOnly: boolean = false;

  @Input() labelName: string = '';
  @Input() isNotNeedLabel: boolean = false;

  onChangeSubscription: Subscription[] = [];

  richEditorForm: UntypedFormGroup = new UntypedFormGroup({});

  private onTouched!: Function;

  private onChanged!: Function;
  @Input() editorHeight: string | undefined;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.richEditorForm = this.formBuilder.group({
      data: [undefined]
    });
  }

  get form(): { [key: string]: AbstractControl } {
    return this.richEditorForm.controls;
  }

  writeValue(value: any): void {
    if (value) {
      this.richEditorForm.patchValue({data: value}, {emitEvent: true});
    }
  }

  // registerOnChange(onChange: any) {
  //   const sub = this.richEditorForm.valueChanges.subscribe(onChange);
  //   this.onChangeSubscription.push(sub);
  // }

  registerOnChange(onChange: any) {
    const sub = this.richEditorForm
      .get('data')!
      .valueChanges
      .subscribe(value => {
        onChange(value);
      });

    this.onChangeSubscription.push(sub);
  }


  registerOnTouched(onTouched: Function) {
    this.onTouched = onTouched;
  }

  ngOnDestroy() {
    for (let sub of this.onChangeSubscription) {
      sub.unsubscribe();
    }
  }
}
